import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { Textarea } from '@/components/ui/textarea'
import type { ItemStatus } from '@/constants/item'
import type { LocalizedSelectOption } from '@/types/ui'
import { type Dispatch, type SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

export function StatusSection({
  newStatus,
  setNewStatus,
  statusNote,
  setStatusNote,
  manualItemStatuses,
  isSubmitting,
  onSubmit,
}: {
  newStatus: string
  setNewStatus: Dispatch<SetStateAction<string>>
  statusNote: string
  setStatusNote: Dispatch<SetStateAction<string>>
  manualItemStatuses?: LocalizedSelectOption[]
  isSubmitting: boolean
  onSubmit: () => void
}) {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-3" data-testid="status-form">
      <Select value={newStatus} onValueChange={v => setNewStatus(v as ItemStatus)}>
        <SelectTrigger className="bg-secondary/50 text-xs w-full" data-testid="status-select">
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="bg-card text-foreground">
          {manualItemStatuses?.map(status => (
            <SelectItem key={status.value} value={status.value} data-testid={`status-select-option-${status.value}`}>
              {status.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <div className="flex flex-col gap-1.5">
        <Label className="text-xs">{t('scans.field.note')}</Label>
        <Textarea
          data-testid="status-note"
          value={statusNote}
          onChange={e => setStatusNote(e.target.value)}
          className="bg-secondary/50 text-xs"
          rows={3}
          placeholder={t('scans.placeholder.statusNote')}
        />
      </div>
      <Button data-testid="status-submit-button" onClick={onSubmit} className="text-xs" disabled={isSubmitting}>
        {t('scans.status.confirm')}
      </Button>
    </div>
  )
}
